import gql from "graphql-tag";

// Staff props
const FoodStaffProps = gql`
    fragment FoodStaffProps on Staff {
        id
        surname
        first_name
        middle_name
        designation {
            id
            name
        }
    }
`;

const FoodProps = gql`
    fragment FoodProps on Food {
        id
        amountTaken
        foodOffered
        datetime
        created_at
        meal
        author {
            ...FoodStaffProps
        }
        preference
    }
    ${FoodStaffProps}
`;

const LIST = gql`
    query GetFoodIntakes($id: ID!) {
        GetFoodIntakes(id: $id) {
            docs {
                ...FoodProps
            }
        }
    }
    ${FoodProps}
`;

const CREATE = gql`
    mutation NewFoodIntake($model: InputFood!) {
        NewFoodIntake(model: $model) {
            message
            doc {
                ...FoodProps
            }
        }
    }
    ${FoodProps}
`;
export { LIST, CREATE };
